import React, { useRef } from "react";

import {
  CommonCommentPill,
  CommonCommentSettings,
} from "@common/components/Input/MessageInput/CommonCommentPill/CommonCommentPill";
import { useCommonCommentsConsumer } from "@main/pages/Administration/consumers/useCommonCommentsConsumer";

import Input, { InputElementType } from "../Input";
import * as Styled from "./MessageInput.styles";

interface Props {
  placeholder?: string;
  onMessageSend?: (message: string) => Promise<void>;
  onChange?: (text: string) => void;
  value: string;
  autoFocus?: boolean;
  testId?: string;
  icontestid?: string;
  sendToUserButton?: JSX.Element;
  sendButtonText?: string;
  sendingButtonText?: string;
  withoutSendButton?: boolean;
  maxLength?: number;
  loading?: boolean;
  onCommonCommentClick?: (text: string) => void;
  onCommonCommentSettingsClick?: () => void;
}

export default function MessageInput(props: Props) {
  const inputWrapperRef = useRef<HTMLTextAreaElement>(null);

  const { commonComments } = useCommonCommentsConsumer({});

  const sendMessage = async () => {
    await props.onMessageSend?.(props.value);
    props.onChange?.("");
  };

  const handleKeydownEvent = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.stopPropagation();
      inputWrapperRef?.current?.blur();
      sendMessage();
    }
  };

  const handleChangeEvent = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    inputWrapperRef?.current?.focus();
    props.onChange?.(event.target.value);
  };

  return (
    <div>
      {commonComments.length > 0 ? (
        <Styled.CommonCommentsSection>
          {commonComments.map((comment) => (
            <CommonCommentPill
              key={comment.title}
              title={comment.title}
              text={comment.message}
              onClick={() => props.onCommonCommentClick?.(comment.message)}
            />
          ))}
          <CommonCommentSettings onClick={props.onCommonCommentSettingsClick} />
        </Styled.CommonCommentsSection>
      ) : null}

      <Input
        autoFocus={props.autoFocus}
        elementType={InputElementType.TEXTAREA}
        innerRef={inputWrapperRef}
        placeholder={props.placeholder}
        value={props.value}
        onChange={handleChangeEvent}
        onKeyDown={handleKeydownEvent}
        withSendButton={!props.withoutSendButton}
        maxLength={props.maxLength}
        toggleButton={props.sendToUserButton}
        onSendButtonClick={sendMessage}
        testId={props.testId}
        icontestid={props.icontestid}
        rows={5}
        sendButtonText={props.loading ? props.sendingButtonText : props.sendButtonText}
        disabled={props.loading}
      />
    </div>
  );
}
